if (!customElements.get('pdp-boothub')) {
  class PdpBoothub extends HTMLElement {
    connectedCallback() {
      this.mediaElements = this.querySelectorAll('.pdp-boothub__media');
      this.overlay = this.querySelector('.pdp-boothub__overlay');
      if (!this.mediaElements.length) return;

      this.ticking = false;
      this.isVisible = false;

      this.observer = new IntersectionObserver(
        (entries) => {
          this.isVisible = entries[0].isIntersecting;
        },
        { threshold: 0 }
      );
      this.observer.observe(this);

      this.onScroll = () => {
        if (!this.ticking && this.isVisible) {
          this.ticking = true;
          requestAnimationFrame(() => {
            this.updateParallax();
            this.ticking = false;
          });
        }
      };

      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.updateParallax();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      if (this.observer) this.observer.disconnect();
    }

    updateParallax() {
      const rect = this.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const progress = (windowHeight - rect.top) / (windowHeight + rect.height);
      const clamped = Math.max(0, Math.min(1, progress));
      // Shift from 0 (top of scroll) to -30% of section height (bottom of scroll)
      // The media is 130% tall, so -30% shift keeps it fully covering the frame
      const maxShift = rect.height * 0.3;
      const translateY = -(clamped * maxShift);
      const transform = `translateY(${translateY}px)`;
      this.mediaElements.forEach((el) => { el.style.transform = transform; });
      if (this.overlay) this.overlay.style.transform = transform;
    }
  }

  customElements.define('pdp-boothub', PdpBoothub);
}
